.panel {
  width: 320px;
  height: 100%;
  background: var(--kh-surface);
  border-right: 1px solid var(--kh-border);
  display: flex;
  flex-direction: column;
  box-shadow: var(--kh-shadow-1);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--kh-border);
}

.title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.close {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: var(--kh-text-muted);
  padding: 2px 8px;
  border-radius: 4px;
}
.close:hover {
  background: var(--kh-off-white);
  color: var(--kh-text-primary);
}

.search {
  margin: 12px 16px;
  padding: 8px 10px;
  border: 1px solid var(--kh-border);
  border-radius: 6px;
  font: inherit;
}

.list {
  flex: 1;
  overflow-y: auto;
  margin: 0;
  padding: 0 8px 8px;
  list-style: none;
}

.row {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

.row:hover:not(:disabled) {
  background: var(--kh-off-white);
}

.row:disabled {
  opacity: 0.5;
  cursor: default;
}

.rowName {
  font-weight: 600;
  font-size: var(--kh-size-body);
}

.rowMeta {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
}

.empty,
.error {
  padding: 24px 16px;
  color: var(--kh-text-muted);
  font-size: var(--kh-size-meta);
}

.error {
  color: var(--kh-red);
}
